export default {
	title: "Centro Personale",
	subTitle: ["Profilo", "Sicurezza", "Sistema"],
	menu: [
		"Modifica le informazioni personali",
		"Nome utente",
		"Aggiorna la password",
		"Aggiorna la password di transazione"
	],
	updatePassword: {
		form: {
			label: ["Vecchia password", "Nuova password", "Conferma la nuova password"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Vecchia password", "Nuova password", "Conferma la nuova password"]
		}
	}
};
